export const sanitizeFilename = (name) => {
    if (typeof name !== 'string' || name === '') {
        return 'untitled.js';
    }

    const sanitized = name
        .toLowerCase()
        .replace(/\s+/g, '-')      // Replace spaces with -
        .replace(/[^\w-]+/g, '')   // Remove all non-word characters
        .replace(/--+/g, '-');     // Replace multiple - with a single -
    
    return `${sanitized}.js`;
};

export const ensureArray = (item) => {
    if (!item) return [];
    return Array.isArray(item) ? item : [item];
};